var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { TranslateService } from '@ngx-translate/core';
import { OrderService } from './../../order/order.service';
import { Observable } from 'rxjs/Observable';
import { Component } from '@angular/core';
var OrderListComponent = (function () {
    function OrderListComponent(orderService, translate) {
        this.orderService = orderService;
        this.translate = translate;
        this.loading = true;
    }
    OrderListComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.list = this.orderService.getOrdersList()
            .catch(function (error) {
            var title = _this.translate.get('Error');
            var text = _this.translate.get('An error occured. Please try again.');
            Observable.forkJoin(title, text).subscribe(function (res) {
                swal({
                    title: res[0],
                    text: res[1],
                    type: 'warning',
                    showCancelButton: false,
                    confirmButtonText: 'OK'
                });
            });
            return Observable.throw("Error loading list of requests");
        })
            .finally(function () {
            _this.loading = false;
        });
        this.language = this.translate.currentLang;
    };
    OrderListComponent = __decorate([
        Component({
            selector: 'cx-dashboard-order-list',
            templateUrl: './order-list.component.html'
        }),
        __metadata("design:paramtypes", [OrderService, TranslateService])
    ], OrderListComponent);
    return OrderListComponent;
}());
export { OrderListComponent };
//# sourceMappingURL=order-list.component.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/order-list/order-list.component.js
// module id = 581
// module chunks = 0